import {
  MemberProfile,
  MembershipDependentIdentityDocumentType,
} from "@/services/core-api-adapter";
import DocMedsDeliveryInfo from ".";

export default function DocMedsDeliveryInfoExamples() {
  return (
    <DocMedsDeliveryInfo
      onBackButtonClick={() => {
        console.log("Back button clicked");
      }}
      onNextButtonClick={(selectedMember) => {
        console.log("Next button clicked with member:", selectedMember);
      }}
      dependants={[
        {
          memberId: "",
          firstName: "Nuki",
          lastName: "Persona",
          identityDocumentType:
            MembershipDependentIdentityDocumentType.ID_NUMBER,
          identityDocumentValue: "9603124800089",
          sexAtBirth: "female",
          dateOfBirth: "1996-03-12",
          identityDocumentCountryOfIssue: "ZAF",
        },
        {
          memberId: "",
          firstName: "Nuki",
          lastName: "Test",
          identityDocumentType: null,
          identityDocumentValue: null,
          sexAtBirth: "female",
          dateOfBirth: "1996-03-12",
          identityDocumentCountryOfIssue: "ZAF",
        },
      ]}
      memberProfile={
        {
          firstName: "Lesedi",
          consultation: {
            consultationResponses: [],
            consultationRates: [],
          },
          memberServiceOfferingUsageCount: "1",
          unlimited: false,
          healthProfile: {
            lastUpdatedAt: "2022-07-08T10:26:04Z",
            healthScoreValue: 75,
          },
          benefitCount: 11,
          dependentCount: 1,
          membership: {
            id: "5a9e9e18-9142-44a9-8d85-0dc21759c5f0",
            fullName: "Lesedi",
            beneficiaryCode: "00",
            productCode: "PRIST",
            productFriendlyName: "BEWELL 101",
            membershipNumber: "UNU-725",
            dependentCount: 7,
          },
          product: {
            pharmacySwitchCode: "E1200ED",
            provider: {
              id: "b958fa21-4fd4-49d3-9a07-ed33b314538e",
              name: "Genric",
              description: null,
              imageUri: "{{STATIC_PLACEHOLDER_IMAGE_URI}}",
            },
            administrator: {
              id: "bbb82cc0-9ea1-40be-8cb2-80e3bbdf7b61",
              code: "NHG",
              name: "National Health Group",
              FileUri: "{{STATIC_PLACEHOLDER_DOCUMENT_URI}}",
              timeZone: "UTC+02:00",
              supportedServices: [
                {
                  type: "CALL_CENTRE",
                  channels: [
                    {
                      type: "PHONE",
                      value: "+27860222286",
                      availability: [
                        {
                          day: "MONDAY",
                          operatingHours: "08:00 - 20:00",
                        },
                        {
                          day: "TUESDAY",
                          operatingHours: "08:00 - 20:00",
                        },
                        {
                          day: "WEDNESDAY",
                          operatingHours: "08:00 - 20:00",
                        },
                        {
                          day: "THURSDAY",
                          operatingHours: "08:00 - 20:00",
                        },
                        {
                          day: "FRIDAY",
                          operatingHours: "08:00 - 20:00",
                        },
                        {
                          day: "SATURDAY",
                          operatingHours: "08:00 - 18:00",
                        },
                        {
                          day: "SUNDAY",
                          operatingHours: "08:00 - 18:00",
                        },
                        {
                          day: "HOLIDAY",
                          operatingHours: "08:00 - 18:00",
                        },
                      ],
                    },
                    {
                      type: "EMAIL",
                      value: "test@test.com",
                      availability: [],
                    },
                    {
                      type: "WHATSAPP",
                      value: null,
                      availability: [],
                    },
                  ],
                },
              ],
            },
          },
        } as unknown as MemberProfile
      }
    />
  );
}
